import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../store/AuthContext";
import { useNavigate } from "react-router-dom";

export default function StudentRouter() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {

    if (!user) return;

    // ✅ CRITICAL FIX: only students allowed
    if (user.role !== "student") return;

    const loginType = localStorage.getItem("logintype");
    const isRoot = window.location.pathname === "/student";

    // ✅ Only redirect when landing on "/"
    if (!isRoot) return;

    if (loginType === "sso") {
      if (user.content === 0) {
        navigate("/student/select-subject-sso", { replace: true });
      } else {
        navigate("/student/select-class-sso", { replace: true });
      }
    } else {
      if (user.content === 0) {
        navigate("/student/select-subject", { replace: true });
      } else {
        navigate("/student/select-class", { replace: true });
      }
    }
  }, [user, navigate]);

  return null;
}
